import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { 
  FormCodeInput, 
  FormLabel, 
  FormInput, 
  FormFeedback, 
  FormCheckbox, 
  FormRadio, 
  FormSelect, 
  FormIncrementalStepper 
} from './index';
import { Button } from '../buttons';
import { Heart } from '../icons';
import IconChooser from './FormIconChooser';
import visitationIcon from '../../assets/images/dashboard/visitation.svg';
import growthIcon from '../../assets/images/dashboard/growth.svg';

const initialValues = {
  defaultOption: true,
  fruit: 'orange',
  minuteStep: { value: 20, label: '20 minutes' },
  disabledStep: { value: 1, label: 'Option 1' },
  codeReject: '54321',
  codeAccept: '12345'
};

function FormShowcase({ onSubmit }) {
  return (
    <Form
      onSubmit={onSubmit || (() => {})}
      initialValues={initialValues}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className="form-showcase">
          {/* Standard Inputs (These use render props properly, so they stay) */}
          <Field name="input1">
            {({ input, meta }) => (
              <FormInput
                {...input}
                meta={meta}
                labelRenderer={() => <FormLabel>Label</FormLabel>}
                placeholder="Placeholder1"
              />
            )}
          </Field>

          {/* Centered Labels and Icons */}
          <Field name="input5">
            {({ input, meta }) => (
              <FormInput
                {...input}
                meta={meta}
                labelRenderer={() => <FormLabel>With Icon</FormLabel>}
                placeholder="I hope you’re having a wonderful day"
                icon={Heart}
              />
            )}
          </Field>

          {/* Acceptance and Rejection UI */}
          <Field name="input7">
            {({ input, meta }) => (
              <>
                <FormInput
                  {...input}
                  meta={meta}
                  labelRenderer={() => <FormLabel>Rejected Input</FormLabel>}
                  reject
                  placeholder="Placeholder7"
                />
                <FormFeedback positive={false}>This is a bad thing</FormFeedback>
              </>
            )}
          </Field>

          {/* FIX: Checkbox (Self-wrapping, no outer Field needed) */}
          <FormLabel>Pick options</FormLabel>
          <FormCheckbox name="option1">
            You thought that last label was long but this label is like the Great
            American Novel...
          </FormCheckbox>

          {/* FIX: Radio Buttons (Self-wrapping, no outer Field needed) */}
          <FormLabel>Pick your favourite fruit</FormLabel>
          <FormRadio name="fruit" value="apple">Apples</FormRadio>
          <FormRadio name="fruit" value="orange">Oranges</FormRadio>

          {/* FIX: Icon Chooser (Self-wrapping, no outer Field needed) */}
          <FormLabel>Icon Chooser (medium - default)</FormLabel>
          <IconChooser>
            <FormRadio name="notfruit" value="visitation" imageSrc={visitationIcon}>
              Visitation
            </FormRadio>
            <FormRadio name="notfruit" value="growth" imageSrc={growthIcon}>
              Growth
            </FormRadio>
          </IconChooser>

          {/* FIX: Select Dropdown (Self-wrapping, no outer Field needed) */}
          <FormLabel>Select a color</FormLabel>
          <FormSelect
            name="color"
            placeholder="Color..."
            options={[
              { value: 'red', label: 'Red' },
              { value: 'green', label: 'Green' },
              { value: 'blue', label: 'Blue' }
            ]}
          />

          {/* Stepper Component (Uses render prop, so outer Field is fine) */}
          <FormLabel center>Step through times</FormLabel>
          <Field name="durationB">
            {({ input }) => (
              <FormIncrementalStepper
                {...input}
                min={0}
                step={5}
                formatValue={n => (n ? `${n} minutes` : '')}
              />
            )}
          </Field>

          {/* Code Input (Uses render prop) */}
          <FormLabel>Code entry (visible)</FormLabel>
          <Field name="codeVisible">
            {({ input, meta }) => (
              <FormCodeInput {...input} meta={meta} fields={5} type="number" />
            )}
          </Field>

          <div className="submit-section">
            <FormLabel>Submit, and get values printed to console</FormLabel>
            <Button label="Submit" type="submit" />
          </div>
        </form>
      )}
    />
  );
}

FormShowcase.propTypes = {
  onSubmit: PropTypes.func
};

export default FormShowcase;
